import React, { useEffect, useState } from 'react'
import { FieldsModal, fieldTypes, IFieldsModal } from 'components/Modal/FieldsModal'
import { NavBar } from 'components/NavBar/NavBar'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { clearField, getSingleField } from 'features/fields/fieldsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
  Flex,
  Button,
  Separator,
  H2,
  PageWrapper,
  H1WithBack,
  ItemsGrid,
} from 'styling/GlobalStyles'
import { IDropDownItem } from 'types/fields.interface'
import { OtherText } from 'styling/Typography'

export const SingleField = () => {
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch<AppDispatch>()
  const { singleField, noSubfields } = useSelector((store: RootState) => store.fields)
  const { id } = useParams()

  useEffect(() => {
    dispatch(getSingleField(id))

    return () => {
      dispatch(clearField())
    }
  }, [])

  const dataTypes = ['Text', 'Number', 'DropDown']

  const convertDataForModal = (): IFieldsModal => {
    return {
      id: Number(id),
      name: singleField?.name,
      type: fieldTypes.find(t => t.value == singleField.dataType),
      dropDownItems: singleField.dropDownItems?.map(i => ({ id: Number(i.id), name: i.name, type: fieldTypes.find(t => t.value == i.dataType) })),
      unit: singleField?.unit ? { value: singleField?.unit?.id, label: singleField?.unit.name } : null
    }
  }

  return (
    <>
      <NavBar />

      <PageWrapper>
        <Flex between>
          <H1WithBack title={singleField.name} arrow />
          <Button orange onClick={() => setModal(true)}>
            Edit Field
          </Button>
        </Flex>
        <Separator />
        <H2 mb='1'>Field</H2>
        <Flex gap='1rem' center>
          <TextDisplayCard width='15rem' title={singleField?.name} labelText='Field name' />
          {singleField?.unit?.name && (
            <TextDisplayCard title={singleField?.unit?.name} labelText='Field unit' />
          )}
          <TextDisplayCard title={dataTypes[singleField?.dataType - 1]} labelText='Data type' />
        </Flex>
        <Flex gap='1rem' m='2rem 0' column>
          <H2>Subfields</H2>
          {!noSubfields ? (
            singleField?.dropDownItems?.map((item: IDropDownItem) => {
              return (
                <ItemsGrid columns={2} gap='1rem' key={item.id} width='60%'>
                  <TextDisplayCard labelText='Data type' title={dataTypes[item.dataType - 1]} />
                  <TextDisplayCard labelText='Value' title={item.name} />
                </ItemsGrid>
              )
            })
          ) : (
            <OtherText>No Subfields</OtherText>
          )}
        </Flex>
      </PageWrapper>
      {modal && <FieldsModal value={convertDataForModal()} closeModal={() => setModal(false)} />}
    </>
  )
}
